(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallDeleteController',PhoneCallDeleteController);

    PhoneCallDeleteController.$inject = ['$uibModalInstance', 'entity', 'PhoneCall'];

    function PhoneCallDeleteController($uibModalInstance, entity, PhoneCall) {
        var vm = this;

        vm.phoneCall = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PhoneCall.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
